import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import LoadingSpinner from '../components/LoadingSpinner';
import { ClaimCard } from '../components/pro/vendor/VendorOfferCard';
import { useUser } from '../context/UserContext';
import { useAuth } from '../context/AuthContext';
import { useDialog } from '../context/DialogContext';
import { vendorService } from '../services';

/**
 * /offer/:claimId — what the QR points at (Offers Ops O2). A black Outside-theme page under
 * the ordinary white navbar: the claim card with its QR, or the spent record.
 */
export default function OfferPage() {
  const { claimId } = useParams();
  const navigate = useNavigate();
  const { profile, walletBalance } = useUser();
  const { user, logout } = useAuth();
  const { showConfirm } = useDialog();
  const [claim, setClaim] = useState(null);
  const [state, setState] = useState('loading');

  const load = useCallback(async () => {
    const r = await vendorService.getClaim(claimId);
    if (r.success) { setClaim(r.data); setState('ok'); } else setState('missing');
  }, [claimId]);
  useEffect(() => { load(); }, [load]);

  const release = async (c) => {
    const ok = await showConfirm({ title: 'GIVE IT BACK', message: `Return "${c.title}" to ${c.businessName}? Someone else can claim it.`, confirmLabel: 'GIVE IT BACK', cancelLabel: 'KEEP IT' });
    if (!ok) return;
    const r = await vendorService.releaseClaim(c.id);
    if (r.success) navigate('/my-tickets?tab=offers');
  };

  return (
    <div className="min-h-screen bg-black">
      <Navbar user={profile || user} walletBalance={walletBalance} onLogout={async () => { await logout(); navigate('/'); }} onLogoClick={() => navigate('/featured')} />
      <div className="mx-auto flex max-w-md flex-col items-center px-4 py-10 font-mono" style={{ gap: 16 }}>
        {state === 'loading' && <LoadingSpinner />}
        {state === 'missing' && (
          <div className="w-full border-2 border-white p-6 text-center">
            <p className="font-bold uppercase text-white" style={{ fontSize: 14, letterSpacing: '0.1em' }}>THIS CODE DOESN’T LEAD ANYWHERE</p>
            <p className="mt-2" style={{ fontSize: 12, color: '#9CA3AF' }}>The claim was given back, or the link is wrong.</p>
            <button type="button" onClick={() => navigate('/pros')} className="mt-4 border-2 border-white px-4 py-2 font-bold uppercase text-white hover:bg-white hover:text-black" style={{ fontSize: 11, letterSpacing: '0.05em' }}>BROWSE PROS</button>
          </div>
        )}
        {claim && (
          <>
            <ClaimCard claim={claim} size={176} onRelease={release} />
            <button type="button" onClick={() => navigate(`/pro/${claim.businessSlug}`)} className="font-bold uppercase underline text-white hover:opacity-80" style={{ fontSize: 11, letterSpacing: '0.05em' }}>{claim.businessName.toUpperCase()} →</button>
            {claim.isMine && <button type="button" onClick={() => navigate('/my-tickets?tab=offers')} className="uppercase underline" style={{ fontSize: 11, letterSpacing: '0.05em', color: '#9CA3AF' }}>ALL YOUR OFFERS</button>}
          </>
        )}
      </div>
    </div>
  );
}
